/**
 * @file: useTaskHeaderMetrics.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useIsAsideLayout } from '@euler/components/Aside';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useIsMobileLayout } from '@euler/functions/responsiveness';
import { useSystemMetrics } from '@euler/functions/useSystemMetrics';

const kHeaderMaxExtend = 300;
const kImageInitialScale = 2;
const kVehicleInfoHeight = 90;
const kVehicleInfoMarginTop = 8;
const kVehicleImageWidth = 90;
const kVehicleImageHeight = 60;
const kOffset = 44;

export const useTaskHeaderMetrics = () => {
  const { rpx } = useResponsiveContext();

  const isAside = useIsAsideLayout();
  const isMobileLayout = useIsMobileLayout();

  const {
    navBarHeight,
    safeAreaFrame,
    isTablet,
    safeAreaInsets,
    statusBarHeight,
  } = useSystemMetrics();

  const headerHeight =
    navBarHeight + rpx(kVehicleInfoHeight + kVehicleInfoMarginTop + kOffset);

  const headerMaxExtend = rpx(kHeaderMaxExtend);

  const paddingTop = safeAreaInsets.top + (isAside ? statusBarHeight : 0);

  return {
    isTablet,
    isMobileLayout,
    statusBarHeight,
    safeAreaInsets,
    safeAreaFrame,
    navBarHeight,
    headerMaxExtend,
    headerHeight,
    offset: rpx(kOffset),
    vehicleInfoHeight: rpx(kVehicleInfoHeight),
    vehicleImageHeight: rpx(kVehicleImageHeight),
    vehicleImageWidth: rpx(kVehicleImageWidth),
    initialImageScale: kImageInitialScale,
    paddingTop: paddingTop,
  };
};
